import { createReducer } from '@reduxjs/toolkit' ;
import { getOrderSummaryRequest, getOrderSummarySuccess, getOrderSummaryFailure, getOrderHistoryRequest, getOrderHistorySuccess, getOrderHistoryFailure, getOrderDownloadRequest, getOrderDownloadFailure, getOrderDownloadSuccess, clearDownloadTypeData } from '../actions/ordersPageActions';

const initialState = {
	orderSummaryLoading: false,
	orderSummaryRows: null,
	orderSummaryError: '',
	orderHistoryLoading: false,
	orderHistoryRows: {},
	orderHistoryRowsError: '',
	orderDownloadData: null,
	orderDownloadSelection: [],
	orderDownloadLoading: false
}

const ordersPageReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getOrderSummaryRequest, (state) => {
			state.orderSummaryLoading = true;
        }).addCase(getOrderSummarySuccess, (state, action) => {
            state.orderSummaryLoading = false;
            state.orderSummaryRows = action.payload.data;
			state.orderSummaryError = '';
        }).addCase(getOrderSummaryFailure, (state, action) => {
            state.orderSummaryLoading = false;
			state.orderSummaryRows = null;
			state.orderSummaryError = action.payload.error;
        })

		.addCase(getOrderHistoryRequest, (state) => {
			state.orderHistoryLoading = true;
        }).addCase(getOrderHistorySuccess, (state, action) => {
            state.orderHistoryLoading = false;
            state.orderHistoryRows = action.payload.data;
			state.orderHistoryRowsError = '';
        }).addCase(getOrderHistoryFailure, (state, action) => {
            state.orderHistoryLoading = false;
			state.orderHistoryRows = null;
			state.orderHistoryRowsError = action.payload.error;
        })


		.addCase(getOrderDownloadRequest, (state, action) => {
			state.orderDownloadLoading = true;
			state.orderDownloadSelection = action.payload.selectionValue
        }).addCase(getOrderDownloadSuccess, (state, action) => {
            state.orderDownloadLoading = false;
            state.orderDownloadData = action.payload?.data || [];
        }).addCase(getOrderDownloadFailure, (state, action) => {
            state.orderDownloadLoading = false;
			state.orderDownloadData = {msg: 'error', details: action.payload.error};
        }).addCase(clearDownloadTypeData, (state, action) => {
			state.orderDownloadSelection = []
        })
		
		.addDefaultCase(() => { });
});
export default ordersPageReducer;
